import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
//import { PoetHeart } from 'lucide-react'; // Removed problematic import
import { Heart } from 'lucide-react'; //Imported Heart
// --- Helper Functions ---
// const generateRandom = (min, max) => Math.random() * (max - min) + min;

// --- Keyframes ---

const fadeInOut = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

const heartAnimation = keyframes`
  0% {
    transform: scale(1) rotate(0deg);
    
  }
  50% {
    transform: scale(1.2) rotate(10deg);
    
  }
  100% {
    transform: scale(1) rotate(0deg);
    
  }
`;

const poemBoom = keyframes`
  0% { transform: scale(0.8); opacity: 0; }
  30% { transform: scale(1.1); opacity: 1; }
  70% { transform: scale(1.0);  }
  100% { transform: scale(1.05); opacity: 1; }
`;

// --- Styled Components ---

const SurpriseContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 15px;
  margin-bottom: 50px;
  background: rgba(255, 240, 245, 0.1);
`;

const Message = styled(motion.p)`
  text-align: center;
  font-size: 1.2em;
  color: #e91e63;
  margin-bottom: 20px;
  font-family: 'Dancing Script', cursive;
  animation: ${fadeInOut} 4s infinite;
`;

const PoemContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
  max-width: 400px;
  border-radius: 15px;
  margin-bottom: 20px;
  background-clip: padding-box;
  border: 2px solid transparent;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    margin: -2px;
    border-radius: 17px;
    background: linear-gradient(to bottom, #ffc0cb, #f48fb1);
    opacity: 0.7;
  }
  
  animation: ${poemBoom} 3s ease;
`;

const Poem = styled.p`
  text-align: center;
  font-size: 1.1em;
  color: #d81b60;
  font-family: 'Kalam', cursive;
  line-height: 1.6;
  white-space: pre-line;
  padding: 10px;

`;

const HeartWrapper = styled(motion.div)`
  width: 120px;
  height: 100px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  color: #f44336;
  animation: ${heartAnimation} 3s ease-in-out infinite;
`;

const RomanticSurprise = () => {
  const showHearts = useState(true);
  const [message, setMessage] = useState("A special poem for a special someone...");
  const timeoutRef = useRef(null);
  const [poem] = useState(`
तेरी आँखों में दिखता है जहान मेरा,
तेरी साँसों में बसता है अरमान मेरा।
जन्मदिन तेरा है, और धड़कता है दिल मेरा,
तू ही है सुबह मेरी, तू ही है शाम मेरा।

हर दुआ में तेरा नाम, हर खुशी में तू है,
कैसे कहूँ कि तू क्या है, मेरी ज़िंदगी क्या है।
आज ये दिन है तेरा, और मैं हूँ यहाँ,
लेकर आ गयी हूँ मैं, ये प्यार का तोहफा यहाँ।

जन्मदिन मुबारक हो, मेरे प्यार, मेरे यार,
तू ही है मेरा सब कुछ, मेरा संसार।,
तू ही है मेरा जीवन का सहारा।
`);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setMessage("Here's a small token of my love.");
    }, 3000);

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);



  return (
    <SurpriseContainer
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeInOut" }}
    >
      <Message>{message}</Message>
      <AnimatePresence>
        {showHearts && (
          <HeartWrapper>
            <Heart size={80} />  {/* Replaced PoetHeart with Heart */}
          </HeartWrapper>
        )}
      </AnimatePresence>
      <PoemContainer>
        <Poem>
          {poem}
        </Poem>
      </PoemContainer>
    </SurpriseContainer>
  );
};

export default RomanticSurprise;
